// extracted by mini-css-extract-plugin
export default {"root":"SignIn_root__xDbQN","logo":"SignIn_logo__vHNH2","header":"SignIn_header__tleM+","body":"SignIn_body__bgwe3","footer":"SignIn_footer__JiU50","divider":"SignIn_divider__EIDnr"};